<!--
  A banner for a condition that must never be hidden. EMERGENCY, FALLBACK and OFFLINE
  raise one, and no route change or responsive breakpoint may collapse it.
-->
<script setup lang="ts">
import { computed } from 'vue';
// Aliased: a prop is also called `icon`, and in <script setup> both would be in
// template scope under the same name.
import { icon as resolveIcon } from '../icons.js';

const props = withDefaults(
  defineProps<{
    tone?: 'danger' | 'warning' | 'info';
    icon?: string;
    title: string;
  }>(),
  { tone: 'warning', icon: 'TriangleAlert' },
);

const IconComponent = computed(() => resolveIcon(props.icon));
</script>

<template>
  <div class="shio-banner" :class="`shio-banner--${tone}`" role="alert">
    <component :is="IconComponent" :size="18" aria-hidden="true" />
    <div class="shio-banner__text">
      <strong>{{ title }}</strong>
      <span v-if="$slots.default" class="shio-body-sm"><slot /></span>
    </div>
    <div v-if="$slots.action" class="shio-banner__action">
      <slot name="action" />
    </div>
  </div>
</template>

<style scoped>
.shio-banner__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.shio-banner__action {
  flex-shrink: 0;
}
</style>
